import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectionService } from '@services/connection-service';
import { Router } from '@angular/router';
import { CsIconModule } from '@components/icon';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

/** Progress at which the AOV threshold is met and the free gift is unlocked. */
const AOV_COMPLETE_PERCENTAGE = 100;

@Component({
  selector: 'app-aov-banner',
  imports: [CommonModule, CsIconModule, LottieComponent],
  templateUrl: './app-aov-banner.html',
  standalone: true
})
export class AovBannerComponent implements OnChanges {
  @Input() amountRemaining: number = 0;
  @Input() freeProductBannerImage: string = '';
  @Input() percentageDone: number = 0;
  @Input() isEnglishLanguage: boolean = true;
  @Input() displayWhenAmountRemainingIsZero: boolean = false;
  @Input() displayInCartPage?: boolean = false;

  /** Plays once per threshold crossing; `complete` retires it so it does not replay on every render. */
  readonly confettiOptions: AnimationOptions = {
    path: '/assets/animation.json',
    loop: false,
  };
  private confettiPlayed: boolean = false;

  constructor(
    private readonly conn: ConnectionService,
    private readonly router: Router,
  ) {}

  /** The bar is full: the copy switches to the congratulations state and the fill turns green. */
  get isAovComplete(): boolean {
    return this.percentageDone >= AOV_COMPLETE_PERCENTAGE;
  }

  get showConfetti(): boolean {
    return this.isAovComplete && !this.confettiPlayed;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Re-arm the confetti when the cart drops back below the threshold, so crossing it again celebrates.
    if (changes.percentageDone && !this.isAovComplete) {
      this.confettiPlayed = false;
    }
  }

  onConfettiComplete(): void {
    this.confettiPlayed = true;
  }

  aovBannerClickHandler(): void {
    if (!this.router.url.includes('/cart')) {
      this.conn.navigateToURL('/cart');
    } else {
      this.conn.navigateToURL('/user/order/reorder?showAll=true');
    }
  }
}
